<template>
  <div>
    <v-dialog ref="dialog" v-model="menu" width="290px">
      <template #activator="{ on }">
        <div v-on="on">
          <slot v-bind="{ computedDate: computedDate }"></slot>
        </div>
      </template>
      <v-date-picker
        v-model="date"
        :disabled="disabled"
        scrollable
        v-bind="$props"
        :locale="locale"
        @input="onInput"
      >
      </v-date-picker>
    </v-dialog>
  </div>
</template>

<script>
import moment from 'moment'
export default {
  props: {
    value: {
      default: undefined
    },
    min: {
      default: undefined
    },
    max: {
      default: undefined
    },
    allowedDates: {
      default: undefined
    },
    format: {
      type: String,
      default: 'DD/MM/YYYY'
    },
    disabled: {
      type: Boolean,
      default: false
    },
    locale: {
      type: String,
      default: 'en'
    }
  },
  data() {
    return {
      date: this.value ? moment(this.value).format('YYYY-MM-DD') : undefined,
      menu: false
    }
  },
  computed: {
    computedDate() {
      return this.value ? moment(this.value).format(this.format) : this.value
    }
  },
  watch: {
    value() {
      if (this.value) {
        this.date = moment(this.value).format('YYYY-MM-DD')
      }
    }
  },
  methods: {
    onInput(date) {
      this.menu = false
      this.$emit('input', date)
      this.$emit('change', date)
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/elements/DatepickerCustomDialog.vue